import { User } from "../../domain";
import {
  Endpoints,
  RemoteDataSource,
  UserRemoteDataSourceError,
} from "../core";

export class UserRemoteDataSource extends RemoteDataSource {
  public async loginWithPassword(
    phone: string,
    password: string
  ): Promise<string> {
    try {
      const res = await this.post(Endpoints.loginWithPassword, {
        body: {
          phone_number: phone,
          password,
        },
      });
      return res.data.token;
    } catch (error) {
      if (!error.response) throw UserRemoteDataSourceError.networkError();
      if (error.response.data.password === "The password is wrong") {
        throw UserRemoteDataSourceError.wrongPasswordError();
      }
      throw UserRemoteDataSourceError.serverError();
    }
  }

  public async getUserInfo(): Promise<User> {
    try {
      const res = await this.get(Endpoints.infoUser);
      return new User().deserialize(res.data);
    } catch (error) {
      if (!error.response) throw UserRemoteDataSourceError.networkError();
      throw UserRemoteDataSourceError.serverError();
    }
  }
}
